import useMeetData from '@usas/ui-web/state/meet/UseMeetData';

const useMeetAddSessionsDetail = () => {
  const { meetState } = useMeetData();

  return {
    meetState
  };
};

export default useMeetAddSessionsDetail;